import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useNavigate } from 'react-router-dom';

interface AccessDeniedProps {
  message?: string;
  showContactSupport?: boolean;
  onBack?: () => void;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  message = 'You do not have permission to access this resource.',
  showContactSupport = true,
  onBack,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleContactSupport = () => {
    // Navigate to settings or contact support
    navigate('/settings');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          py: 4,
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: 4,
            textAlign: 'center',
            width: '100%',
          }}
        >
          <BlockIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2,
            }}
          />
          <Typography variant="h5" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            {message}
          </Typography>

          {showContactSupport && (
            <Typography variant="body2" color="text.secondary" paragraph>
              If you believe this is an error, please contact your chapter administrator or support.
            </Typography>
          )}

          <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button variant="outlined" color="primary" onClick={handleBack}>
              Go Back
            </Button>
            {showContactSupport && (
              <Button variant="contained" color="primary" onClick={handleContactSupport}>
                Contact Support
              </Button>
            )}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied;
